import React from "react";
import { fetchQuizes,updateQuiz, getAvailablePuppiesBaseOnQuizAnswers } from "../../../actions/quiz";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import { Loader } from "../../../components/loader";
import "react-select/dist/react-select.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, { textFilter, selectFilter } from "react-bootstrap-table2-filter";
import { NotificationManager } from "react-notifications";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { BreadCrumb } from "../../../components/breadcrumb";
import Responsive from "react-responsive";
import { formatPhoneNumber, convertToTitleCase } from  '../../../utils/helper';
import Select from "react-select";
import _ from "lodash";
import moment from "moment";

const { SearchBar } = Search;
const $ = window.$;
const userPermissionList = {
  listSocialMediaSubmission : 'list-social-media-submission',
};

let timeOptions = [{ label: "This Week", value: "this_week" },
{ label: "Last Week", value: "last_week" },
{ label: "All", value: "all" }];

const TIMEDURATION = {
  THIS_WEEK : 'this_week',
  LAST_WEEK : 'last_week',
  ALL : 'all',
}

class QuizWithAnswers extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    quizWithUser: [],
    listSocialMediaSubmissionFlag:[],
    loading: true,
    quizNotes: '',
    quizId: '',
    loadingQuizUpdate: false,
    timeDuration : 'this_week',
    loadingQuizAvailablePuppies: false,
    availablePuppies : [],
  };

  tableHeaderColumnData = [
    {
      dataField: "fullname",
      text: "Full Name",
      sort: true,
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
      formatter: (cell,row) => <a href={`mailto:${cell}?body=Hello, ${convertToTitleCase(row.fullname)}!`} className="hyperlink">{cell}</a>
    },
    {
      dataField: "contactNumber",
      text: "Phone Number",
      sort: true,
      formatter: (cell) => <a href={`tel:${cell}`} className="hyperlink-phone-number">{cell}</a>
    },
    {
      dataField: "createdAt",
      text: "Submitted Date",
      sort: true,
      formatter: (cell) => cell
    },
    {
      dataField: "sendUpdates",
      text: "Send Updates",
      sort: true,
      formatter: (cell) => cell
    },
    {
      dataField: 'notes',
      text: 'Notes',
      sort: true,
      formatter: (cell, row) => {
        return ( 
        <div>
          <a
           href=""
           onClick={(e) => {this.openNotesEditModal(e,row)}}
           style ={{ color : "#575962" }}
          > 
             {cell}
             <i className="la la-edit"></i>
          </a>
        </div>
        );
      }
    },
    {
      dataField: "source",
      text: "Source",
      sort: true,
      formatter: (cell, row) => {
        return  cell ? cell :"";
      }  
    },
    {
      dataField: '',
      text: 'Available Puppies',
      sort: true,
      formatter: (cell, row) => {
        return ( 
        <div>
          <a
           href=""
           onClick={(e) => {this.openAvailablePuppiesModal(e,row)}}
           style ={{ color : "#575962" }}
          > 
       
            <i className="far fa-eye"></i>
          </a>
        </div>
        );
      }
    },
  ];

  subTableHeaderColumnData = [
    {
        dataField: "id",
        text: "#",
        sort: true,
        headerStyle: (selector, id) => {
            return { textAlign: "center", width: "95px" };   // removed partial line here
        },
        formatter: (cell, row) => {
          return <div style={{textAlign: "center"}}>{row.QuizQuestion.id}</div>
        }  
    },
    {
      dataField: "id",
      text: "Question",
      sort: true,
      formatter: (cell, row) => {
        return row.QuizQuestion.question
      }  
    },
    {
      dataField: "id",
      text: "Answers",
      sort: true,
      formatter: (cell, row) => {
        let answers = "";

        if(row && row.quiz_friendly_and_sociable){
            answers += row.quiz_friendly_and_sociable.answer +"<br>"
        }

        if(row && row.quiz_on_guard_and_protective){
            answers += row.quiz_on_guard_and_protective.answer +"<br>"
        }

        if(row && row.quiz_energetic_and_active){
            answers += row.quiz_energetic_and_active.answer +"<br>"
        }

        if(row && row.quiz_very_energetic_60_120_mins_daily_exercise){
            answers += row.quiz_very_energetic_60_120_mins_daily_exercise.answer +"<br>"
        }

        if(row && row.quiz_moderately_energetic_60_90_mins_daily_exercise){
            answers += row.quiz_moderately_energetic_60_90_mins_daily_exercise.answer +"<br>"
        }

        if(row && row.quiz_low_energy_30_45_mins_daily_exercise){
            answers += row.quiz_low_energy_30_45_mins_daily_exercise.answer +"<br>"
        }

        if(row && row.quiz_extra_small_under_10_lbs){
            answers += row.quiz_extra_small_under_10_lbs.answer +"<br>"
        }

        if(row && row.quiz_small_under_20_lbs){
            answers += row.quiz_small_under_20_lbs.answer +"<br>"
        }

        if(row && row.quiz_medium_20_50_lbs){
            answers += row.quiz_medium_20_50_lbs.answer +"<br>"
        }

        if(row && row.quiz_large_50_100_lbs){
            answers += row.quiz_large_50_100_lbs.answer +"<br>"
        }

        if(row && row.quiz_extra_large_over_100_lbs){
            answers += row.quiz_extra_large_over_100_lbs.answer +"<br>"
        }

        if(row && row.quiz_minimal){
            answers += row.quiz_minimal.answer +"<br>"
        }

        if(row && row.quiz_moderate){
            answers += row.quiz_moderate.answer +"<br>"
        }

        if(row && row.quiz_bring_on_the_fluff){
            answers += row.quiz_bring_on_the_fluff.answer +"<br>"
        }

        if(row && row.quiz_no_shedding){
            answers += row.quiz_no_shedding.answer +"<br>"
        }

        if(row && row.quiz_yes){
            answers += row.quiz_yes.answer +"<br>"
        }

        if(row && row.quiz_no){
            answers += row.quiz_no.answer +"<br>"
        }

        if(row && row.quiz_no_preference){
            answers += row.quiz_no_preference.answer +"<br>"
        }

        if(row && row.quiz_exploring_options_no_set_timeline){
          answers += row.quiz_exploring_options_no_set_timeline.answer +"<br>"
        }

        if(row && row.quiz_ready_now_within_a_month){
          answers += row.quiz_ready_now_within_a_month.answer +"<br>"
        }

        if(row && row.quiz_planning_ahead_1_3_months){
          answers += row.quiz_planning_ahead_1_3_months.answer +"<br>"
        }
        
        if(row && row.quiz_under_$500){
          answers += row.quiz_under_$500.answer +"<br>"
        }

        if(row && row.quiz_$600_to_$1800){
          answers += row.quiz_$600_to_$1800.answer +"<br>"
        }

        if(row && row.quiz_$1900_to_$3200){
          answers += row.quiz_$1900_to_$3200.answer +"<br>"
        }

        if(row && row.quiz_$9500_to_$25000){
          answers += row.quiz_$9500_to_$25000.answer +"<br>"
        } 

        return (
            <span dangerouslySetInnerHTML={{__html: answers}}></span>
        );
      }  
    }
  ];

  expandRow = {
    renderer: (row, rowIndex) => (  
      <div>            
                   <ToolkitProvider
                       keyField="id"
                       data={ row.QuizUserAnswers }
                       columns={this.subTableHeaderColumnData}
                       search
                       hover={true}
                       filter={filterFactory()} 
                       
                                       
                     >
                       {props => (
                         <div>  
                                                      
                             <BootstrapTable  
                              classes="breedersPuppyChildTable"                          
                               {...props.baseProps}                        
                      
                             />  
                        </div>                      
                     
                       )}
                     </ToolkitProvider>  
               </div>
   ),
     showExpandColumn: true ,
     expandHeaderColumnRenderer: ({ isAnyExpands }) => {
             if (isAnyExpands) {
             return <b style={{cursor: 'pointer'}}><i className="fas fa-chevron-circle-up"></i></b>;
             }
             return <b style={{cursor: 'pointer'}}><i className="fas fa-chevron-circle-down"></i></b>;
           },
     expandColumnRenderer: ({ expanded }) => {
             if (expanded) {
               return (
                 <div style={{cursor: 'pointer', marginTop: '0px'}}><i className="fas fa-chevron-circle-up"></i></div>
               );
             }
             return (
               <div style={{cursor: 'pointer', marginTop: '0px'}}><i className="fas fa-chevron-circle-down"></i></div>
             );
           }
  };

  componentDidMount() {
    this.loadQuizByTime();
    this.loadPermissions();
  }

  loadQuizByTime(){
    //load this week quiz records
    let startDate = moment().weekday(1).format('YYYY-MM-DD');
    let endDate = moment(startDate).clone().add(6,'days').format('YYYY-MM-DD');
    let timeDuration = {
      startDate : startDate,
      endDate : endDate
     }
    this.props.fetchQuizes(timeDuration);
  }

  loadPermissions(){  
    let allPermission = JSON.parse( localStorage.getItem('userPermissions')) ; 
      if(allPermission && allPermission.length > 0){ 
          const listSocialMediaSubmission =  allPermission.find(item => item.Module.module_name == userPermissionList.listSocialMediaSubmission);            
          this.setState({ listSocialMediaSubmissionFlag: listSocialMediaSubmission ? listSocialMediaSubmission.value : true,});
      }
    
  }

  openNotesEditModal = (e,row) => {
    e.preventDefault();
    let notes = row.notes ? row.notes : "";
    this.setState({ quizId : row.id, quizNotes : notes });
    $("#notes-edit-modal").modal("show"); 

  }

  openAvailablePuppiesModal = (e,row) => {
    e.preventDefault();  
    if(row && row.QuizUserAnswers && row.QuizUserAnswers.length > 0){                                                 
      this.setState({ loadingQuizAvailablePuppies : true, availablePuppies :[] });
      this.props.getAvailablePuppiesBaseOnQuizAnswers(row.QuizUserAnswers);
      $("#available-puppies-modal").modal("show"); 
    }else{
      NotificationManager.error("User quiz data not found");
    }
  
  }

  changeVal = event => {
    let value = event.target.value;
    this.setState({
      ...this.state,
      [event.target.name]: value
    });
  };

  changeTimeOption = timeOption => { 
    if(timeOption && timeOption.value){
      let startDate = 'null_date';
      let endDate = 'null_date';
      this.setState( { timeDuration : timeOption.value });
      if(timeOption.value === TIMEDURATION.THIS_WEEK ){
          //Get first date of monday
        startDate = moment().weekday(1).format('YYYY-MM-DD');
        endDate = moment(startDate).clone().add(6,'days').format('YYYY-MM-DD');
      }
      else if(timeOption.value === TIMEDURATION.LAST_WEEK){    
        startDate = moment().weekday(-6).format('YYYY-MM-DD');
        endDate = moment(startDate).clone().add(6,'days').format('YYYY-MM-DD');
      }else{
        startDate = 'null_date';
        endDate = 'null_date';
      }
      let timeDuration = {
       startDate : startDate,
       endDate : endDate
      };
      this.props.fetchQuizes(timeDuration);
    }  

  }

  submitNotes = () => {
    let quizId = this.state.quizId;
    if(quizId){
      let data = {
        notes : this.state.quizNotes
      }
      this.setState( { loadingQuizUpdate : true });
      this.props.updateQuiz(quizId,data);
    }else{
      NotificationManager.warning("Quiz record not found");
    }
  }


  resetPuppies(){
    this.setState({ availablePuppies: [] });
    $("#available-puppies-modal").modal("hide");
  }

  componentWillReceiveProps = (nextProps) => {
    if (
      nextProps.data.quizReducer.quizWithUser !==
      this.props.data.quizReducer.quizWithUser
    ) {
      let quizWithUser = nextProps.data.quizReducer.quizWithUser;
      const formatedQuizUsers = quizWithUser.map((user)=>{
        user.contactNumber = user.contactNumber ? formatPhoneNumber(user.contactNumber): null;
        return user;
      });

      this.setState({
        quizWithUser: formatedQuizUsers,
        loading: false,
      });
    }

    if( nextProps.data.quizReducer.quizWithUserError !== this.props.data.quizReducer.quizWithUserError ){
      NotificationManager.error("An error occurred while loading the quiz");
      this.setState({  loading: false });  
    } 

    if( nextProps.data.quizReducer.updatedQuiz !== this.props.data.quizReducer.updatedQuiz ){  
      let timeDuration = {
        value : this.state.timeDuration ? this.state.timeDuration  : 'this_week',
      }
      this.changeTimeOption(timeDuration);
      this.setState({ loadingQuizUpdate : false, });
      NotificationManager.success("Quiz record updated successfully.");
      $("#notes-edit-modal").modal("hide"); 
    }

    if( nextProps.data.quizReducer.updatedQuizError !== this.props.data.quizReducer.updatedQuizError ){
      this.setState({ loadingQuizUpdate : false });
      NotificationManager.error("An error occurred while updating the quiz record");
      $("#notes-edit-modal").modal("hide"); 
    }     

    if( nextProps.data.quizReducer.availablePuppiesUserAnswer !== this.props.data.quizReducer.availablePuppiesUserAnswer ){
      this.setState({ availablePuppies : nextProps.data.quizReducer.availablePuppiesUserAnswer, loadingQuizAvailablePuppies : false });
    }  
  };

  items = [{ title: "Quiz", to: "/quiz" }];

  render() {       
    const { quizNotes,loadingQuizUpdate,timeDuration,loadingQuizAvailablePuppies, availablePuppies } = this.state;
    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <BreadCrumb items={this.items} />
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="m-portlet m-portlet--mobile">
                <div className="m-portlet__head medical-record-head-btn-set">
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">
                        Quiz
                      </h3>
                    </div>
                  </div>
                  <div className="m-portlet__head-tools">
                    <ul className="m-portlet__nav">
                      <li className="m-portlet__nav-item">               
                        <div style={{width: "150px", margin: "0 auto", marginTop: "15px"}}>
                          <Select
                            options={timeOptions}
                            value={timeDuration}
                            name="timeDuration"
                            onChange={this.changeTimeOption}
                            placeholder="Select The Time"
                          />
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="m-portlet__body medical-record-content subscribe-to-pet-table">
                  <div className="tab-content">
                  { !this.state.loading ?
                    <ToolkitProvider
                      keyField="id"
                      data={this.state.quizWithUser}
                      columns={this.tableHeaderColumnData}
                      search
                      hover={true}
                      filter={filterFactory()}
                    >
                      {(props) => (
                        <div>
                          <div className="px-0 mb-4 search-bar">
                            <div className="col-lg-3 px-0 inner-addon right-addon m--align-right">
                              <i className="fas fa-search mt-1"></i>
                              <SearchBar {...props.searchProps} />
                          </div>
                        </div>
                          <div className="mb-2">
                            <small className="small-text">
                              *If you experience any difficulty in viewing the quiz, please make sure your
                              cache is cleared and completed a hard refresh. IOS users might have to use a private
                              window.
                            </small>
                          </div>
                          <BootstrapTable 
                            classes="petTable" 
                            {...props.baseProps} 
                            pagination={paginationFactory()} 
                            expandRow={ this.expandRow } 
                        />
                        </div>
                      )}
                    </ToolkitProvider>:
                    <div className="center-row">
                      <Loader size={50}/>
                    </div>
                  }
                  </div>
                </div>
              </div>
            </div>
          </div>
           {/* Quiz notes edit stat */}
            <div className="modal fade show" id="notes-edit-modal" tabIndex="-1" role="dialog">
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">Edit Notes</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="form-group m-form__group">
                      <label for="exampleTextarea">Notes</label>
                      <textarea 
                        className="form-control m-input m-input--air" 
                        id="quizNotes"
                        rows="3"                
                        name="quizNotes"
                        onChange={this.changeVal}   
                        placeholder=""
                        value={quizNotes}                    
                      >
                      </textarea>
                    </div>
                  </div>
                  <div className="modal-footer">   
                   { !loadingQuizUpdate ?           
                    <div>
                      <button type="button" className="btn btn-secondary m-btn--pill mx-2" data-dismiss="modal">Cancel</button>
                      <button type="button" onClick={() => this.submitNotes()} className="btn btn-primary m-btn--pill">Submit</button>
                    </div>:
                    <div className="center-row">
                       <Loader size={50} />
                    </div>
                   }               
                  </div>
                </div>
              </div>
            </div>
           {/* Quiz notes edit end */}
           {/* Quiz user available pappies modal start */}
            <div className="modal fade show" id="available-puppies-modal" tabIndex="-1" role="dialog">
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">Available Puppies</h5>
                    <button type="button" className="close" onClick={() => this.resetPuppies()} aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                  <div className="row ">
                   {availablePuppies && availablePuppies.length > 0 ?
                      <div className="col-12">
                        <div className="m-portlet m-portlet--full-height ">
                          <div className="m-portlet__body">
                          <div className="m-widget3">
                            <div className="row">
                              <div className="col-xl-12">
                                { availablePuppies.map((m,i)=>(                            
                                  <div className="m-widget3__item" key={i}>
                                    <div className="m-widget3__header">
                                      <div className="m-widget3__user-img">
                                        <img className="m-widget3__img" src={process.env.REACT_APP_S3_PATH + '/' + m.avatar_path + '/' + m.avatar_file_name} alt=""/>                                   
                                      </div>
                                      <div className="m-widget3__info pb-2">
                                        <a style={{cursor: "pointer"}}>
                                         <span className="m-badge m-badge--info px-2"> Pet Id:<strong> {m.pet_id}</strong></span>
                                        </a>
                                        <br/>
                                        <p className="m-widget3__text mb-0">
                                          <strong>Breed:</strong> { m.breed_type }
                                        </p>                                  
                                      </div>                                                                
                                                                    
                                    </div>
                                  </div>                                                    
                                 ))}
                                                                                                                
                              </div>
                                                        
                            </div>
                            </div>
                          </div>                        
                        </div>
                      </div>:null
                   }
                  </div>
                  </div>
                  <div className="modal-footer">   
                   { !loadingQuizAvailablePuppies ?           
                    <div>                
                      <button type="button" onClick={() => this.resetPuppies()} className="btn btn-primary m-btn--pill">Okay</button>
                    </div>:
                    <div className="center-row">
                       <Loader size={50} />
                    </div>
                   }               
                  </div> 
                </div>
              </div>
            </div>
           {/* Quiz user available pappies modal end */}
        </div>
      </div>
    );
  }
}

export const Mobile = (props) => <Responsive {...props} maxWidth={767} />;
export const Default = (props) => <Responsive {...props} minWidth={768} />;

const mapStateToProps = (state) => ({
  data: state,
});

const mapDispatchToProps = (dispatch) => ({
    fetchQuizes: (timeDuration) => {
    dispatch(fetchQuizes(timeDuration));
  },
  updateQuiz: (id,data) => {
    dispatch(updateQuiz(id,data));
  },
  getAvailablePuppiesBaseOnQuizAnswers:(data) => {
    dispatch(getAvailablePuppiesBaseOnQuizAnswers(data));
  }
});

QuizWithAnswers = connect(mapStateToProps, mapDispatchToProps)(QuizWithAnswers);

export default withRouter(QuizWithAnswers);
